export { default as NCollapseTransition, collapseTransitionProps } from './src/CollapseTransition';
